import { ISpeaker } from "@/models/IEvents";

interface Iprops {
  data: ISpeaker;
}

const LillySpeakers = ({ data }: Iprops) => {
  return (
    <div className="w-full border border-border-stone rounded-[0.25rem] flex flex-col p-4">
      <div className="text-base text-[#212121] leading-6 font-normal">
        {data.speaker.name}
      </div>
      <div className="text-sm leading-5 font-normal text-[#212121]">
        {data.speaker.designation}
      </div>
      <div>
        <span className="text-[#2A2E86] text-sm leading-5 font-bold">
          Talk Time:
        </span>
        &nbsp;
        <span className="text-[#2A2E86] text-sm leading-5">
          {data.talkTime}
        </span>
      </div>
      <div>
        <span className="text-[#2A2E86] text-sm leading-5 font-bold">
          Poster Time:
        </span>
        &nbsp;
        <span className="text-[#2A2E86] text-sm leading-5">
          {data.posterTime}
        </span>
      </div>
    </div>
  );
};

export default LillySpeakers;
